import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  UploadFileRes,
  ActionRes,
  MasterProducsReq,
  MasterProducsRes,
  ManufacturReq,
  ManufacturRes,
  MerchantSummaryReq,
  MerchantSummaryRes,
  OverallDashboardReq,
  OverallDashboardRes,
} from './types'

export const getMasterProductAction = createAsyncAction(
  'DASHBOARD_MINIRMX/GET_MASTER_PRODUCT_REQ',
  'DASHBOARD_MINIRMX/GET_MASTER_PRODUCT_SUCCESS',
  'DASHBOARD_MINIRMX/GET_MASTER_PRODUCT_FAILURE',
)<MasterProducsReq, MasterProducsRes, Error>()

export const getManufaturDashboardAction = createAsyncAction(
  'DASHBOARD_MINIRMX/GET_MANU_DASHBOARD_REQ',
  'DASHBOARD_MINIRMX/GET_MANU_DASHBOARD_SUCCESS',
  'DASHBOARD_MINIRMX/MANU_DASHBOARD_FAILURE',
)<ManufacturReq, ManufacturRes, Error>()

export const getMerchantSummaryDashboardAction = createAsyncAction(
  'DASHBOARD_MINIRMX/GET_MERCHANT_SUMMARY_DASHBOARD_REQ',
  'DASHBOARD_MINIRMX/GET_MERCHANT_SUMMARY_DASHBOARD_SUCCESS',
  'DASHBOARD_MINIRMX/GET_MERCHANT_SUMMARY_DASHBOARD_FAILURE',
)<MerchantSummaryReq, MerchantSummaryRes, Error>()

export const getOverallDashboardAction = createAsyncAction(
  'DASHBOARD_MINIRMX/GET_OVERALL_DASHBOARD_REQ',
  'DASHBOARD_MINIRMX/GET_OVERALL_DASHBOARD_SUCCESS',
  'DASHBOARD_MINIRMX/GET_OVERALL_DASHBOARD_FAILURE',
)<OverallDashboardReq, OverallDashboardRes, Error>()

export const uploadFileAction = createAsyncAction(
  'DASHBOARD_MINIRMX/UPLOAD_DELIVERY_REQ',
  'DASHBOARD_MINIRMX/UPLOAD_DELIVERY_SUCCESS',
  'DASHBOARD_MINIRMX/UPLOAD_DELIVERY_FAILURE',
)<FormData, ActionRes, Error>()

export const clearEventAction = createStandardAction('DASHBOARD_MINIRMX/CLEAR_EVENT')<void>()
